import axios from 'axios';

// const API = axios.create({ baseURL: "https://nascodefy.herokuapp.com" });
const API = axios.create({ baseURL: 'http://localhost:9001/api/v1' });

// function ini akan berkerja pada setiap request
API.interceptors.request.use((req) => {
  // untuk mengirimkan kembali token ke backend, dan backend middleware
  // sehingga akan memverifikasi apa yang kita lakukan
  if (localStorage.getItem('profile')) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem('profile')).token
    }`;
  } 

  return req;
});

export const signIn = (formData) => API.post('/login', formData);
export const allThemes = () => API.get('/themes');
export const singleTheme = (id) => API.get(`/theme/${id}`)
export const allCustomer = () => API.get('/customers');
export const singleCustomer = (id) => API.get(`/customer/${id}`)
// export const fetchThemes = (page) => API.get(`/posts?page=${page}`);
